export const validateLoginIdMassage =
  'Use letters (a-z) or numbers (0-9), the length should be at least 4 symbols';

export const validateLoginId = (loginId: string): true | string => {
  const regex = /^[a-zA-Z0-9]{4,}$/;
  return regex.test(loginId) || validateLoginIdMassage;
};
